import { render, staticRenderFns } from "./ProdutoUnico.vue?vue&type=template&id=9c9ff0ae&"
import script from "./ProdutoUnico.vue?vue&type=script&lang=js&"
export * from "./ProdutoUnico.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoUnico.vue?vue&type=style&index=0&id=9c9ff0ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports